import { createEntityStore, type EntityState, type EntityStore } from '@datorama/akita';
import { type SearchEntry } from 'types/models';

export type SearchState = EntityState<SearchEntry>;

const store: EntityStore<SearchState> = createEntityStore({}, { resettable: true, name: 'search/searchHistory' });

export default store;
